import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../selectors/state";
import { ProvisionedAppType } from "../../../../marketplace/provisioned/types";

type MarketplaceConnectedResourceWarningProps = {
  resources: ProvisionedAppType[];
  entity: string;
};

const MarketplaceConnectedResourceWarning: React.FC<
  MarketplaceConnectedResourceWarningProps
> = ({ resources, entity }) => {
  if (!Array.isArray(resources)) {
    resources = [resources];
  }
  const orchestrationStacks = useSelector(
    (state: State) => state.orchestration_stacks?.ORCHESTRATION_STACKS_LIST,
  );

  const warnings = useMemo(() => {
    if (entity !== "Provisioned App") return [];

    return resources.map((resource) => {
      const isHeatDeployment =
        resource?.deploymentTypeTitle?.toLowerCase() === "heat";
      const stack = orchestrationStacks?.[resource.resourceId as string];

      return {
        id: stack?.id || resource.resourceId,
        name: stack?.stack_name || resource.appTitle || "Unknown",
        type: isHeatDeployment ? "Orchestration Stack" : "Other Resource",
      };
    });
  }, [entity, resources, orchestrationStacks]);

  if (warnings.length === 0) return null;

  return (
    <div className="margin-top-20 margin-bottom-20">
      {warnings.map((stack, index) => (
        <p key={index}>
          {stack.type}: ID: {stack.id}, Name: {stack.name}
        </p>
      ))}
    </div>
  );
};

export default MarketplaceConnectedResourceWarning;
